import { useDeleteTag } from 'features/tags';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from 'shared/components/ui/confirm-dialog';
import { Tag } from 'shared/types/tag';

export type DeleteTagDialogProps = {
  tag: Tag;
  onClose: () => void;
};

export const DeleteTagDialog: React.FC<DeleteTagDialogProps> = ({
  tag,
  onClose,
}) => {
  const { t } = useTranslation();
  const { submit: deleteTag } = useDeleteTag();

  const onDelete = () => {
    deleteTag(tag);
    onClose();
  };

  return (
    <ConfirmDialog
      open
      title={t('context-menus.tags.forms.delete.title')}
      message={t('context-menus.tags.forms.delete.body', { name: tag.name })}
      onConfirm={onDelete}
      onCancel={onClose}
      confirmLabel={t('context-menus.tags.forms.delete.footer.submit')}
      cancelLabel={t('context-menus.tags.forms.delete.footer.cancel')}
    />
  );
};
